import React, { Fragment, useState } from 'react';


const NewClient = ({ refresh_clients }) => {

    const [name, setName] = useState("");
    const [client_description, setClient_description] = useState("");
    const [NDIS_number, setNDIS_number] = useState("");
    const [success, setSuccess] = useState(false);
    const [exists, setExists] = useState(false);

    function reset() {
        setName("")
        setClient_description("")
        setNDIS_number("")
        setSuccess(false)
        setExists(false)
    }

    const onSubmitForm = async (e) => {
        e.preventDefault();

        const body = { name, client_description, NDIS_number }

        const response = await fetch("https://www.beyondcommunityaccess.com/clients/new", {
            method: "POST",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body)
        }).then(function (response) {
            if (response.status == 401 || response.status == 409 || response.status == 403) {
                setExists(true)
                setSuccess(false)
            } else {
                setSuccess(true)
                setExists(false)
                setName("")
                setClient_description("")
                setNDIS_number("")
            }
        })
        refresh_clients()
    }


    return (
        <Fragment>
            <button type="button" className="btn btn-info m-3 float-right" data-toggle="modal" data-target={`#newClient`}>
                Add new client
            </button>

            <div className="modal fade" id={`newClient`}>
                <div className="modal-dialog">
                    <div className="modal-content">



                        <div className="modal-header">
                            <h4 className="modal-title">Add a new Client</h4>
                            <button type="button" className="close" data-dismiss="modal" onClick={() => reset()}>&times;</button>
                        </div>

                        <form onSubmit={onSubmitForm}>
                            <div className="modal-body">
                                <p className="mt-2">NDIS Number</p>
                                <input required placeholder="NDIS Number" type="number" className="form-control" value={NDIS_number} onChange={e => setNDIS_number(e.target.value)} />
                                <p className="mt-2">Name</p>
                                <input required placeholder="Name" type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} />
                                <p className="mt-2">Description</p>
                                <input required placeholder="Description" type="text" className="form-control" value={client_description} onChange={e => setClient_description(e.target.value)} />
                                <button className="btn btn-success mt-1">Create</button>
                                {success && <p className="text-success">It Worked</p>}
                                {exists && <p className="text-danger">Client already exists!</p>}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-success" data-dismiss="modal" onClick={() => reset()}>Close</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default NewClient;